<app-form-header class="backoffice-page-header"></app-form-header>

<div>
  <div class="page-content mat-elevation-z2">

    <mat-accordion>
      <mat-expansion-panel class="filter-style" [expanded]="panelOpenState" (opened)="panelOpenState = true"
                           (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title fxLayout="row" fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <span>
              Cuadro de filtros
            </span>
          </mat-panel-title>
          <mat-panel-description *ngIf="!panelOpenState">
            Haga clic para desplegar y acceder a los filtros
          </mat-panel-description>
          <mat-panel-description *ngIf="panelOpenState">
            Haga clic para ocultar los filtros.
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="formFilter" fxLayout="row" fxLayoutAlign="space-around center">
          <mat-form-field appearance="outline">
            <mat-label>Comercio</mat-label>
            <input matInput placeholder="Comercio" formControlName="nombreFantasia">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Ruc</mat-label>
            <input matInput placeholder="Ruc" formControlName="ruc">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" formControlName="email">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Web</mat-label>
            <input matInput placeholder="Email" formControlName="web">
          </mat-form-field>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <div>
      <table mat-table [dataSource]="dataSource" matSort matSortActive="documento">

        <ng-container matColumnDef="nombreFantasia">
          <th mat-header-cell *matHeaderCellDef> Comercio </th>
          <td mat-cell *matCellDef="let e"> {{e.nombreFantasia}} </td>
        </ng-container>

        <ng-container matColumnDef="ruc">
          <th mat-header-cell *matHeaderCellDef> Ruc </th>
          <td mat-cell *matCellDef="let e"> {{e.ruc}} </td>
        </ng-container>

        <ng-container matColumnDef="web">
          <th mat-header-cell *matHeaderCellDef> Web </th>
          <td mat-cell *matCellDef="let e"> {{e.web}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef> Email</th>
          <td mat-cell *matCellDef="let e"> {{e.email}} </td>
        </ng-container>
        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef> Acciones</th>
          <td mat-cell *matCellDef="let e">
            <button mat-menu-item (click)="mostrarDetalle(e)">
                    <mat-icon>visibility
                    </mat-icon>
                  </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [length]="paginacion?.cantidad" [pageSize]="paginacion?.por_pagina" (page)="obtenerDatos($event)">
    </mat-paginator>
  </div>
</div>
